import { render, staticRenderFns } from "./BaseInputAutocomplete.vue?vue&type=template&id=5fdc8f4b&"
import script from "./BaseInputAutocomplete.vue?vue&type=script&lang=js&"
export * from "./BaseInputAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports